<template>
    <header class="header">
        <nav class="navigation container">
            <div class="row">
                <h1 v-if="mode === 'public'" class="name-container name-container-public col-10">
                    <router-link to="/">
                        <span class="name-red">Swiss</span>
                        <span class="name-blue">Marine</span>
                    </router-link>
                </h1>
                <h1 v-if="mode === 'admin'" class="name-container col-10">
                    <router-link to="/">
                        <span class="name-red">S</span>
                        <span class="name-blue">M</span>
                        <span class="admin-text">admin</span>
                    </router-link>
                </h1>
                
                <div v-show="showLinks" class="menu" id="menu">
                    <router-link v-for="link in navigationLinks" v-bind:key="link.name" :to="link.route" class="nav-item">{{link.name}}</router-link>
                </div>
                <a v-show="sandwichIsVisible && showLinks" v-on:click="menuClick" class="menu-button col-2" role="button" aria-label="open menu">
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" 
                                xmlns:xlink="http://www.w3.org/1999/xlink" 
                                version="1.1" 
                                id="Two-Tone" 
                                x="0px" 
                                y="0px" 
                                viewBox="0 0 48 48" 
                                style="enable-background:new 0 0 24 24;fill:#144378;" 
                                xml:space="preserve" 
                                width="40px" 
                                height="40px">
                            <rect x="2" y="25" width="40" height="4"></rect>
                            <rect x="2" y="12" width="40" height="4"></rect>
                            <rect x="2" y="38" width="40" height="4"></rect>
                        </svg>
                    </span>
                </a>
                <a v-show="!sandwichIsVisible && showLinks" v-on:click="menuClick" class="menu-button col-2" style="display: none" role="button" aria-label="close menu">
                    <span>
                        <svg version="1.1" 
                                id="Capa_1" 
                                xmlns="http://www.w3.org/2000/svg" 
                                xmlns:xlink="http://www.w3.org/1999/xlink" 
                                x="0px" 
                                y="0px"
                                width="24px" 
                                height="24px" 
                                viewBox="0 0 357 357" 
                                style="enable-background:new 0 0 357 357;fill:#144378;" 
                                xml:space="preserve">
                            <g id="close">
                                <polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 
                                    214.2,178.5 "></polygon>
                            </g>
                        </svg>
                    </span>
                </a>
            </div>
        </nav>
        <div v-if="!sandwichIsVisible && showLinks" v-on:click="menuClick" class="menu-sandwich">
            <router-link v-for="link in navigationLinks" v-bind:key="link.name" :to="link.route" class="nav-item">{{link.name}}</router-link>
        </div>
    </header>
</template>

<script>
export default {
    name: "Header",
    props: [
        'mode',
        'showLinks'
    ],
    data() {
        return {
            sandwichIsVisible: true,
            publicLinks: [{
                route: "/home/about",
                name: "about us"
            },{
                route: "/home/fleet",
                name: "fleet"
            },{
                route: "/home/clients",
                name: "clients"
            },{
                route: "/home/contacts",
                name: "contacts"
            },{
                route: "/press",
                name: "press"
            }],
            adminLinks: [{
                route: "/admin/about",
                name: "about"
            },{
                route: "/admin/numbers",
                name: "numbers"
            },{
                route: "/admin/fleet",
                name: "fleet"
            },{
                route: "/admin/members",
                name: "members"
            },{
                route: "/admin/clients",
                name: "clients"
            },{
                route: "/admin/contacts",
                name: "contacts"
            },{
                route: "/admin/policy",
                name: "policy"
            },{
                route: "/admin/press",
                name: "press"
            },{
                route: "/admin/careers",
                name: "careers"
            }]
        }
    },
    computed: {
        navigationLinks() {
            if (this.mode === "admin") {
                return this.adminLinks;
            } else {
                var careers = this.$store.getters.orderedCareers;

                if (careers && careers.length) {
                    return [...this.publicLinks, {
                        route: "/careers",
                        name: "careers"
                    }];
                } else {
                    return this.publicLinks;
                }
            }
        }
    },
    methods: {
        menuClick() {
            this.sandwichIsVisible = !this.sandwichIsVisible;
        }
    }
}
</script>

<style scoped>
    .header {
        position: fixed;
        top: 0;
        width: 100%;
        background-color: rgba(255,255,255,0.98);
        z-index: 1001;
        box-shadow: 0 0.2em 0.4em  rgba(120, 120, 120, 0.5);
        height: 5em;
    }

    .navigation {
        height: 5em;
    }

    .navigation > .row {
        text-align: center;
        align-items: center;
    }

    .name-container {
        font-family: 'Californian', 'Times New Roman', Times, serif;
        font-variant: small-caps;
        letter-spacing: 0.1em;
        vertical-align: middle;
        line-height: inherit;
        margin: auto;
        padding: 0.7em 0 0.65em;
        font-size: 1.6em;
    }

    .name-blue {
        color: #144378;
    }

    .name-red {
        color: #e72131;
    }

    .menu-button.hidden {
        display: none;
    }

    .menu,
    .menu-sandwich {
        text-transform: uppercase;
        font-weight: 600;
    }

    .menu {
        display: none;
        font-size: 1.125em;
        padding-right: 0;
        margin: auto;
        padding-bottom: 0.3em;
        flex: 0 0 72%;
        max-width: 72%;
    }

    .menu-sandwich {
        text-align: center;
        background-color: rgba(255,255,255,0.98);
        z-index: 1002;
        font-size: 1.125em;
        padding-bottom: 1.5em;
    }

    .menu .nav-item {
        color: #144378;
    }

    .menu-sandwich .nav-item {
        color: #144378;
        padding: 1.5em;
    }

    .nav-item {
        padding: 0.7em;
        color: #000;
        display: block;
    }

    .nav-item:hover,
    .nav-item.router-link-active {
        color: #e72131;
    }

    svg {
        width: 90%;
    }
    
    .admin-text {
        font-variant-caps: small-caps;
    }

    .menu .nav-item:last-child {
        padding-right: 0;
    }

    @media only screen and (min-width: 400px) {
        .name-container {
            font-size: 2em;
        }

        .header,
        .navigation {
            height: 6.3em;
        }
    }

    @media only screen and (min-width: 576px) {
        .name-container {
            font-size: 2.5em;
            padding-top: 0.35em;
            padding-left: 0.35em;
            text-align: start;
        }

        .menu-sandwich {
            text-align: center;
            background-color: rgba(255,255,255,0.98);
            z-index: 9;
        }

        .menu-button {
            margin-top: -0.7em;
        }

        svg {
            width: 100%;
        }
    }

    @media only screen and (min-width: 920px) {
        .menu {
            display: -webkit-flex; /* Safari */
            -webkit-justify-content: right; /* Safari 6.1+ */
            justify-content: right;
            display: flex;
            z-index: 2;
        }

        .menu-sandwich {
            display: none;
        }

        .nav-item {
            padding: 0.4em;
            display: inline;
        }

        .name-container-public + .menu .nav-item {
            padding: 0.6em;
        }

        .menu-button {
            display: none;
        }

        .name-container {
            flex: 0 0 14%;
            max-width: 14%;
        }

        .name-container.name-container-public {
            flex: 0 0 28%;
            max-width: 28%;
        }

        .admin-text {
            line-height: 0.01em;
            font-size: 0.6em;
            display: block;
        }
    }

    @media only screen and (min-width: 1200px) {
        .name-container {
            font-size: 2.7em;
        }

        .nav-item {
            padding-left: .7em;
            padding-right: .7em;
        }

        .name-container-public + .menu .nav-item {
            padding-left: 1.4em;
            padding-right: 1.4em;
        }
    }
</style>